import script from "./RotationChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./RotationChart.vue?vue&type=script&setup=true&lang=ts"

import "./RotationChart.vue?vue&type=style&index=0&id=572ca8ef&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572ca8ef"]])

export default __exports__